import ActionButton from 'components/ActionButton';
import AddItemConfigToSubscriptionsModal from 'components/AddItemConfigToSubscriptionsModal';
import DeleteActionForTable from 'components/DeleteActionForTableData';
import { tableStyles } from 'css/tableStyles';
import React, { useMemo, useState } from 'react';
import DataTable from 'components/DataTable';
import { removeSubscriptionItemConfig } from 'services';
import { showError } from 'utils';
import styles from './index.module.scss';

const ItemConfig = (props) => {
  const { itemConfig = [],subscriptionId='',refreshFn } = props;
  const [addItemConfigModalOpen, setAddItemConfigModalOpen] = useState(false);

  const removeItem = async (subscriptionId: string,slug: string) => {
    try {
      await removeSubscriptionItemConfig({ id:subscriptionId,slug });
      await refreshFn();
    } catch (e) {
      showError(e);
    }
  };

  const columns = useMemo(
    () => [
      {
        name: 'Slug',
        selector: 'slug',
      },
      {
        name: 'Max Count',
        selector: 'MAX_COUNT',
      },
      {
        name: 'Max Cost',
        selector: 'MAX_COST',
      },
      {
        name: 'Action',
        selector: '',
        // eslint-disable-next-line react/display-name
        cell: (row: Record<string, any>) => (
          <DeleteActionForTable
            onClick={() => {
              removeItem(subscriptionId,row?.slug);
            }}
          />
        ),
      },
    ], [],
  );

  const getHeader = () => {
    return (
      <div className={styles['section-header']}>
        <div className={styles['section-heading']}>Item Config</div>
        <ActionButton
          active={true}
          isLoading={false}
          onClick={()=>setAddItemConfigModalOpen(true)}
          text={
            <>
            Item Config <span className={'ml-3'}>+</span>
            </>
          }
        />
      </div>
    );
  };

  return (
    <div className={styles['inventory-items-container']}>
      {getHeader()}
      { addItemConfigModalOpen && (
        <AddItemConfigToSubscriptionsModal
          subscriptionId={subscriptionId}
          toggleModal={()=>setAddItemConfigModalOpen(!addItemConfigModalOpen)}
          onSuccess={refreshFn}
        />
      )}
      <DataTable
        data={itemConfig}
        columns={columns}
        noHeader={true}
        customStyles={tableStyles}
        highlightOnHover={true}
      />
    </div>
  );
};

export default ItemConfig;
